/// Ошибка с человеческим текстом: её сообщение можно показывать в UI как есть.
///
/// Во Flutter-версии эту роль играли `AuthException`, `PushException`,
/// `AnalyticsException` и родня — каждая несла готовую русскую строку. Здесь
/// один класс с полем `kind`: тип ошибки нужен для логов, а не для ветвления.
export class AppError extends Error {
  readonly kind: string

  constructor(message: string, kind = 'app') {
    super(message)
    this.name = 'AppError'
    this.kind = kind
  }
}

/// Текст для показа пользователю из чего угодно, что прилетело в catch.
export function errorMessage(error: unknown, fallback = 'Что-то пошло не так'): string {
  if (error instanceof AppError) return error.message
  if (error instanceof Error && error.message) return error.message
  if (typeof error === 'string' && error) return error
  return fallback
}
